<script setup lang="ts">
  import { computed, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useAuthStore } from '@/entities/Session';
  import { SimpleLoading } from '@/shared/ui';
  import { useModuleMatrixRevisionScope } from '../../model/useModuleMatrixRevisionScope';
  import QualityRecordMatrixPage from './QualityRecordMatrixPage.vue';

  const route = useRoute();
  const router = useRouter();
  const authStore = useAuthStore();

  const folderCode = computed(() => String(route.params.folderCode ?? ''));
  const { scope } = useModuleMatrixRevisionScope(folderCode);

  // Once the scope resolves, the matrix page owns the branch switch.
  watch(
    () => authStore.selectedBranchId,
    (newBranchId, oldBranchId) => {
      if (newBranchId !== oldBranchId && !scope.value) {
        router.replace({ name: 'Home' });
      }
    }
  );
</script>

<template>
  <QualityRecordMatrixPage
    v-if="scope"
    :key="scope.folderId"
    :scope="scope"
  />
  <div
    v-else
    class="flex h-full w-full items-center justify-center px-6"
    data-testid="module-matrix-revision-resolving"
  >
    <SimpleLoading />
  </div>
</template>
